const colours = {
    Black: {
        type: 'code',
        value: '#000000'
    },
    Blue: {
        type: 'code',
        value: '#40b1e3'
    },
    Brown: {
        type: 'code',
        value: '#bb8c79'
    },
    Green: {
        type: 'code',
        value: '#bad68a'
    },
    Grey: {
        type: 'code',
        value: '#bab5b5'
    },
    Nude: {
        type: 'code',
        value: '#ebd2b5'
    },
    Orange: {
        type: 'code',
        value: '#ff9262'
    },
    Pink: {
        type: 'code',
        value: '#ff8ec8'
    },
    Purple: {
        type: 'code',
        value: '#925A94'
    },
    Red: {
        type: 'code',
        value: '#f55e69'
    },
    White: {
        type: 'code',
        value: '#ffffff'
    },
    Yellow: {
        type: 'code',
        value: '#fedc40'
    }
}

const TEXT_COLOR = '#616161'

const BACKGROUND_COLOR = '#fcfcfc'

const BUTTON_COLOR = '#925A94'

const BLUE_TEXT = '#31a7ef'


export {colours, TEXT_COLOR, BACKGROUND_COLOR, BUTTON_COLOR, BLUE_TEXT}



// WEBPACK FOOTER //
// ./src/constants/colours.js